<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/pc_banner_sup_faq_k.webp')">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />

        <h1 class="main-title">
          勝winを使用中に<br>
          何か問題や疑問がありましたか？
        </h1>

        <ul class="anchor-list">
          <li class="anchor-item">
            <a class="anchorTo" @click="scrollTo('anchor1')">ご登録について</a>
          </li>
          <li class="anchor-item">
            <a class="anchorTo" @click="scrollTo('anchor2')">個人情報について</a>
          </li>
        </ul>
        <ul class="anchor-list">
          <li class="anchor-item">
            <a class="anchorTo" @click="scrollTo('anchor3')">入金について</a>
          </li>
          <li class="anchor-item">
            <a class="anchorTo" @click="scrollTo('anchor4')">出金について</a>
          </li>
          <li class="anchor-item">
            <a class="anchorTo" @click="scrollTo('anchor5')">ゲームについて</a>
          </li>
        </ul>

        <hr class="hr_line my_5r">
        <div id="anchor1" class="section">
          <h1 class="main-title">
            責任あるギャンブル
          </h1>

          <ul class="list-type-Q">
            <li>
              <b class="fw_bold">勝winへの登録方法はどうすればいいですか？</b>
              <p>「新規登録」をクリックし、必要事項を記入したら、登録完了となります。</p>
            </li>

            <li>
              <b class="fw_bold">どのようなデバイスでプレイできますか？</b>
              <p>
                勝winは、すべての携帯デバイスやパソコンに対応しており、いつでもどこでもエンターテインメントをお楽しみいただけます。
              </p>
            </li>

            <li>
              <b class="fw_bold">使える通貨は何がありますか？</b>
              <p>勝winでは日本円での入出金に対応しております。</p>
            </li>

            <li>
              <b class="fw_bold">年齢制限はありますか？</b>
              <p>勝winのご利用は20歳以上の方に限定しております。</p>
            </li>

            <li>
              <b class="fw_bold">プレイ可能な地域はどこですか？</b>
              <p>
                コモロ諸島の法律に基づき、以下の国または地域にお住いのお客様は、勝winの口座開設、またはご利用いただくことができません。<br>
                オーストラリア、オーストリア、コモロ諸島、フランス、ドイツ、オランダ、スペイン、英国、米国、すべてのFATFブラックリスト掲載国。
              </p>
            </li>

            <li>
              <b class="fw_bold">登録したアカウントで、無料ゲームをプレイできますか？</b>
              <p>
                新規登録のお客様には、当サイトのすべてのゲームを体験いただける1回限りの体験ボーナスをご提供いたします。
              </p>
            </li>

            <li>
              <b class="fw_bold">カジノで使用できる通貨は何ですか？</b>
              <p>勝winは日本円の入出金に対応しております。</p>
            </li>

            <li>
              <b class="fw_bold">アカウントはいくつまで作成できますか？</b>
              <p>
                すべてのお客様に、公平かつ厳格に管理された環境上でゲームをお楽しみ頂くため、一人のお客様が複数のアカウントを登録された場合、不正行為とみなします。一世帯に対し、ひとつのデバイス＝ひとつのIPアドレスにつき、ひとつのアカウントのみ使用可能です。勝winはアカウントに関する全ての操作を中止させる権利を保有しておりますので、上記のルールに違反した場合、お客様の全てのキャンペーンへの参加を停止し、該当するウォレット内の残高を没収いたします。
              </p>
            </li>

            <li>
              <b class="fw_bold">自宅以外のコンピューターで利用することはできますか？</b>
              <p>
                はい、問題ございません。ただし、自宅以外のコンピューターで勝winをご利用する際、ご自身のアカウント情報が他人に悪用されることのないよう、十分ご注意ください。また、お客様アカウントが他人に不正に使用されることにより生じた損害につきまして、勝winは一切責任を負いませんので、ご了承ください。
              </p>
            </li>

            <li>
              <b class="fw_bold">VPNを使用してプレイできますか？</b>
              <p>
                勝winでは、VPNやプロキシサーバーなどで実際の利用所在地を隠すことを禁止しております。
              </p>
            </li>

            <li>
              <b class="fw_bold">なぜアカウント登録に個人情報の入力が必要なのですか？</b>
              <p>
                個人情報の入力は、アカウントの正当性を確保し、より良いサービスをご提供するにあたり欠かせないものであり、また規制に準拠することに必要な条件となります。個人情報の入力により、不正行為を防ぎ、アカウントの安全性を確保できます。
              </p>
            </li>

            <li>
              <b class="fw_bold">登録した個人情報の変更はできますか？</b>
              <p>
                お客様が登録された個人情報の変更は出来ません。<br>
                サポートが必要な場合、カスタマーサポートまでお問い合わせください。
              </p>
            </li>

            <li>
              <b class="fw_bold">携帯電話を使用して、登録認証コードを受け取ることはできますか？</b>
              <p>勝winでは、登録認証コードをSMSでお受け取りいただけます。</p>
            </li>
          </ul>
        </div>
        <hr class="hr_line my_5r">

        <h1 id="anchor2" class="main-title">
          個人情報について
        </h1>

        <ul class="list-type-Q">
          <li>
            <b class="fw_bold">アカウント認証用の書類は、どのような書類を、どこに、どのように送れば良いでしょうか？</b>
            <p class="mb_3">
              アカウント認証をクリックし、アカウント認証用の以下の書類をアップロードしてください。
            </p>
            <p class="mb_3">
              1.身分証明書：運転免許証、パスポート、住民基本台帳カード、居留証、マイナンバーカード、特別永住者証明書
            </p>
            <p class="mb_3">
              2.住所確認用書類：住民票、公共料金、携帯電話の請求書、クレジットカードの請求書
            </p>
            <p>
              アップロードできない場合は、「support@katsuwin.ai」までファイルをご送付ください。
            </p>
          </li>

          <li>
            <b class="fw_bold">ログインできません。どうすれば良いですか？</b>
            <p>
              入力されたユーザー名とパスワードが正しいかを再度ご確認ください。その他の原因の場合、カスタマーサービスまでお問い合わせください。
            </p>
          </li>

          <li>
            <b class="fw_bold">メールアドレスはどのように変更できますか？</b>
            <p>
              電子メールまたはライブチャットよりカスタマーサービスまでご連絡ください。<br>連絡の際には、以下の情報をお知らせください：<br>
              「ユーザー名」、「氏名」、「メールアドレス変更理由」、「変更後のメールアドレス」
            </p>
          </li>

          <li>
            <b class="fw_bold">パスワードは変更できますか？</b>
            <p>
              ログイン後、「アカウント認証」ページにある「個人情報」の「パスワード設定」よりご変更ができます。
            </p>
          </li>

          <li>
            <b class="fw_bold">パスワードを忘れた場合、どうすれば良いですか？</b>
            <p>
              ログイン画面にある「パスワードをお忘れ」からユーザー名と電話番号を入力し、再設定ができます。
            </p>
          </li>

          <li>
            <b class="fw_bold">アカウント名を忘れた場合、どうすれば良いですか？</b>
            <p>
              お忘れになったアカウントに関する情報は、「氏名」、「電話番号」、「メールアドレス」を明記の上、「support@katsuwin.ai」までご送付ください。確認次第、早急にご連絡いたします。
            </p>
          </li>

          <li>
            <b class="fw_bold">ユーザー名を変更できますか？</b>
            <p>ユーザー名は、登録完了後に変更することはできません。</p>
          </li>

          <li>
            <b class="fw_bold">メール配信の停止はできますか？</b>
            <p>
              キャンペーンメールの最下部にある「配信停止はこちら」から停止手続きを行うか、電子メールまたはライブチャットを通じてカスタマーサービスまでご連絡ください。<br>
              ご連絡の際は、以下の情報をお知らせください：「ユーザー名」、「氏名」、「メール配信の停止希望」、「メールアドレス」
              <br>
              ご本人確認が完了次第、メール配信停止の手続きを行います。<br>
            </p>
          </li>

          <li>
            <b class="fw_bold">退会や、アカウントの削除はできますか？</b>
            <p>
              退会またはアカウント削除をご希望の場合、「support@katsuwin.ai」まで、「退会またはアカウント削除希望」と明記の上、ご連絡ください。退会後またはアカウントの削除後はログインできなくなり、メールも受信できなくなります。
            </p>
          </li>

          <li>
            <b class="fw_bold">アカウントを凍結したいのですが、どうすれば良いですか？</b>
            <p>
              アカウントの凍結をご希望の場合、「support@katsuwin.ai」まで、「アカウントの凍結」と明記の上、ご連絡ください。アカウントの凍結後はログインできなくなり、メールも受信できなくなります。
            </p>
          </li>

          <li>
            <b class="fw_bold">ライブチャットが開けません。</b>
            <p>
              インターネット接続が一時的に不安定な恐れがございます。その際は、「support@katsuwin.ai」までメールでご連絡ください。
            </p>
          </li>

          <li>
            <b class="fw_bold">カスタマーサポートにはいつ問い合わせできますか？</b>
            <p>
              勝winでは、完全に日本語対応しており、メールとライブチャットで24時間365日サポートを提供しています。
            </p>
          </li>
        </ul>

        <hr class="hr_line my_5r">

        <h1 id="anchor3" class="main-title">
          入金について
        </h1>

        <ul class="list-type-Q">
          <li>
            <b class="fw_bold">どのような入金方法がありますか？</b>
            <p>
              勝winでは、銀行振込、eウォレット、仮想通貨など、さまざまな入金方法をご提供しております。
            </p>
          </li>

          <li>
            <b class="fw_bold">一回あたりの入金額はいくらですか？</b>
            <p>
              銀行振込：最低5,000円～最高2,000,000円<br>
              VegaWallet : 最低1,500円～最高1,000,000円<br>
              Jetonbankt : 最低5,000円～最高1,000,000円<br>
              USDT：最低1,500円～最高1,000,000円
            </p>
          </li>

          <li>
            <b class="fw_bold">USDTとは何ですか？</b>
            <p>
              USDTは、ステーブルコインとして知られる暗号通貨でございます。その価値は米ドルと結びついており、暗号通貨市場における、安定した価値媒体を提供することを目的としております。各USDTは1米ドルの価値を持ち、勝winのお客様に最も広く利用されている方法のひとつでございます。
            </p>
          </li>

          <li>
            <b class="fw_bold">入金にかかる時間はどれくらいですか？</b>
            <p>通常は5～30分ほどで完了いたします。</p>
          </li>

          <li>
            <b class="fw_bold">【ボーナスウォレット】を使用した場合のベット額の上限はいくらですか？</b>
            <p>
              【ボーナスウォレット】を使用し、ベットを行う場合、以下のルールにご注意ください。<br>
              <br>
              スロット、クラッシュでのベットは1回625円まででございます。<br>
              <br>
              ライブ&テーブルはベットは1回3,000円まででございます。
            </p>
          </li>

          <li>
            <b class="fw_bold">入金ボーナスはどうやって獲得できますか？</b>
            <p>
              ご入金申込時に、お客様のご希望に沿ったボーナスキャンペーンにご参加いただくと、特典として受け取ることができます。詳しい内容については、各キャンペーンやプロモーションの詳細をご覧ください。
            </p>
          </li>

          <li>
            <b class="fw_bold">入金ボーナスを申請するメリットは何ですか？</b>
            <p>
              追加ボーナスを受け取ることができ、ボーナスでベットしゲームをプレイすることができます。
            </p>
          </li>

          <li>
            <b class="fw_bold">入金の際に、手数料は必要ですか？</b>
            <p>勝winでは、入金の際の手数料は一切かかりません。</p>
          </li>

          <li>
            <b class="fw_bold">入金時間に制限はありますか？</b>
            <p>いいえ、いつでもご入金いただけます。</p>
          </li>
        </ul>

        <hr class="hr_line my_5r">

        <!-- anchor4 -->
        <h1 id="anchor4" class="main-title">
          出金について
        </h1>

        <ul class="list-type-Q">
          <li>
            <b class="fw_bold">どのような出金方法がありますか？</b>
            <p>
              勝winでは、銀行振込、eウォレット、仮想通貨など、さまざまな出金方法をご提供しております。
            </p>
          </li>

          <li>
            <b class="fw_bold">出金の際に必要な書類などはありますか？</b>
            <p>
              勝winから初回出金の際、ご本人様確認のため、以下のURLより必要書類をご提出いただく必要があります。
            </p>
            <p>https://www.katsuwin.ai/user/KYC</p>
          </li>

          <li>
            <b class="fw_bold">一回あたりの出金額はいくらですか？</b>
            <p>
              銀行振込：最低5,000円～最高3,000,000円<br>
              VegaWallet : 最低1,500円～最高3,000,000円<br>
              Jetonbankt : 最低5,000円～最高3,000,000円<br>
              USDT：最低1,500円～最高3,000,000円<br>
              各出金方法には最低額と最高額の制限がございます。詳細は出金ページにてご確認ください。
            </p>
          </li>
          <li>
            <b class="fw_bold">一日の最大出金額はありますか？</b>
            <p>
              1日に出金できる金額に制限はありません。ただし、1回あたりの出金最大額は3,000,000円までとなります。
            </p>
          </li>

          <li>
            <b class="fw_bold">出金の際に、手数料は必要ですか？</b>
            <p>勝winでは、出金の際の手数料は一切ございません。</p>
          </li>

          <li>
            <b class="fw_bold">入金後すぐに出金できますか？</b>
            <p>
              マネーロンダリング等の不正送金を防止するため、入金直後の出金はできません。ゲームの結果に関わらず、お客様は入金額の「2倍」をベットする必要がございます。この条件を満たした上で出金することが可能です。
            </p>
          </li>

          <li>
            <b class="fw_bold">なぜ出金が完了できないのでしょうか？</b>
            <p>
              初めて出金の際、ご本人様確認の手続きを完了する必要がございます。
              「アカウント認証」をクリックし、以下のご本人様確認用の書類をアップロードしてください。
            </p>
            <ol class="list-type-decimals">
              <li>身分証明書：<br>運転免許証、パスポート、住民基本台帳カード、居留証、マイナンバーカード、特別永住者証明書</li>
              <li>
                住所確認用書類：<br>
                住民票、公共料金、携帯電話の請求書、クレジットカードの請求書
              </li>
            </ol>
            <p>アップロードできない場合は、[support@KatsuWIN.ai]までファイルをご送付ください。</p>
          </li>

          <li>
            <b class="fw_bold">出金するたびに、身分証明書を提出する必要がありますか？</b>
            <p>初回出金する際に、ご本人様確認の手続きを完了していれば、次回からの出金の際に再度ご本人様確認をする必要はございません。</p>
          </li>

          <li>
            <b class="fw_bold">出金には入金と同じ方法が必要ですか？</b>
            <p>はい、同じ方法となります。銀行振込で入金された場合、出金も銀行振込で申請する必要があります。</p>
          </li>

          <li>
            <b class="fw_bold">出金にかかる時間はどれくらいですか？</b>
            <p>出金申請を受けてから速やかに対応いたします。業界トップクラスのスピードをご提供しています。</p>
          </li>

          <li>
            <b class="fw_bold">出金時間に制限はありますか？</b>
            <p>ございません。勝winでは365日、24時間出金サービスをご提供しております。</p>
          </li>
        </ul>

        <hr class="hr_line my_5r">

        <!-- anchor5 -->
        <h1 id="anchor5" class="main-title">
          ゲームについて
        </h1>

        <ul class="list-type-Q">
          <li>
            <b class="fw_bold">どのようなカジノゲームがありますか？</b>
            <p>
              勝winは、世界トップクラスのオンラインカジノゲームプロバイダーを厳選しており、出国しなくても世界各地のゲームをお楽しみいただけます。<br>
              バカラ、ブラックジャック、ルーレットなどのクラシックなカジノゲームをはじめとした6,000種類以上のカジノゲームやスロットをお楽しみいただけます。
            </p>
          </li>

          <li>
            <b class="fw_bold">オンラインライブ&テーブルの利点は何ですか？</b>
            <p>
              ライブ&テーブルでは、コンピューターによる乱数コントロールではなく、ライブディーラーがゲームをホストしており、ゲームの真実性と信頼性を強化していく一方、HDビデオストリーミングを通じてさまざまなゲームの楽しさと臨場感をお楽しみいただけます。ゲームの楽しさと真実性、また信頼性を実現しております。バカラ、ルーレット、ブラックジャックなどのクラシックなカジノゲームを幅広く取り揃えており、時間や場所を問わず、24時間いつでもご自宅で本格的なカジノの雰囲気をご体験いただけます。
            </p>
          </li>

          <li>
            <b class="fw_bold">ゲームの公平性は保たれていますか？</b>
            <p>
              勝winの厳選されたゲームは、高度な先進技術に基づいて構築されております。ライブゲームでは、高度な訓練を受け、教育を受けたディーラーだけがプレーを許され、すべてのゲーム結果はゲームプロバイダーによって監視され、公平性が保たれています。また、全てのゲームにおいて乱数発生装置(RNG)を使用して乱数を生成し、公平性を確保しています。
            </p>
          </li>

          <li>
            <b class="fw_bold">各ゲームの最低ベット額はいくらですか？</b>
            <p>各ゲームによって異なるため、ゲーム内の最低ベット額をご確認ください。</p>
          </li>

          <li>
            <b class="fw_bold">スロットの遊び方を教えてください。</b>
            <p>
              スロットの標準的なプレイ方法は、リールを回転させ、ペイライン上にシンボルが揃うと賞金を獲得できます。
              各ゲームにはユニークなボーナス機能と特別なサウンドとライトエフェクトがございます。<br>

              ステップ1<br>
              スロットの選択:
              スロットによって効果、テーマ、特徴、ペイアウトルールが異なります。<br><br>

              ステップ2<br>
              ベットの設定：ほとんどのスロットでは、1回のベットで賭けられる金額が決まっています。ご予算に合ったベットをしましょう。<br><br>

              ステップ3<br>
              回転ボタンを押すと、エキサイティングなサウンドと光のエフェクトが流れ、勝ちチップが集まるのを待ちます。
            </p>
          </li>

          <li>
            <b class="fw_bold">ライブ&テーブルの遊び方を教えてください。</b>
            <p>
              ライブ&テーブルでは、バカラ、ブラックジャック、ルーレット、フラッシュバカラ、フラッシュルーレット、スピードバカラなどのカードゲームをプレイすることができます。
            </p>
          </li>

          <li>
            <b class="fw_bold">ゲームのプレイ記録はどのように確認できますか？</b>
            <p>アカウント内にある「ゲーム履歴」からご確認いただけます。</p>
          </li>

          <li>
            <b class="fw_bold">ボーナス利用中に禁止ゲームはありますか？</b>
            <p>GekiPachi全種類のパチンコ＆パチスロゲームと競馬は、ボーナスを利用してプレイすることができません。</p>
          </li>

          <li>
            <b class="fw_bold">ボーナス利用中のベット上限はありますか？</b>
            <ol class="list-type-disc">
              <li>「スロット、クラッシュ」での1回625円を超えるベットはできません。超過した場合、違反とみなし、すべての関連ボーナスは没収といたします。</li>
              <li>
                「ライブ&テーブル」で3,000円を超えるベットはできません。超過した場合、違反とみなし、すべての関連ボーナスは没収といたします。ライトニングバカラなどの手数料がかかるライブゲームでは手数料を含めた金額が3,000円以下でないといけません。
              </li>
              <li>
                Bonus BuyまたはFree Spinsを購入する場合、購入額がベット上限額の規定を超えると違反と見なし、すべての関連ボーナスは没収といたします。
              </li>
            </ol>
          </li>

          <li>
            <b class="fw_bold">ゲームが開けません。</b>
            <p>以下をお試しください。</p>
            <ol class="list-type-disc">
              <li>ブラウザのキャッシュ、クッキー、閲覧履歴を削除する</li>
              <li>他のブラウザに変更する（Google Chrome推奨）</li>
              <li>パソコンや携帯電話など、他の機器への登録</li>
              <li>
                お使いのデバイスのオペレーティングシステムとブラウザか最新バージョンを使用していることをご確認ください。
              </li>
              <li>上記を確認後、ブラウザを再起動して再度お試しください。</li>
              <li>
                エラーが発生した場合は、スクリーンショットまたはスクリーンキャストビデオを撮影し、カスタマーサービスまでご連絡ください。
              </li>
            </ol>
          </li>
        </ul>

        <hr class="hr_line my_5r">

        <h1 class="main-title">
          仮想通貨について
        </h1>
        <ul class="list-type-Q">
          <li>
            <b class="fw_bold">どの仮想通貨に対応していますか？</b>
            <p>
              勝winでは、以下の仮想通貨での入出金に対応しております：<br>
              USDT（テザー）、LTC（ライトコイン）、XRP（リップル）、BTC（ビットコイン）、ETH（イーサリアム）、DOGE（ドージコイン）、BCH（ビットコインキャッシュ）、TRX（トロン）、BNB（バイナンスコイン）、USDC（USDコイン）、SHIB（シバイヌ）、TETH（テセリウム）
            </p>
          </li>

          <li>
            <b class="fw_bold">仮想通貨の入出金にかかる時間はどれくらいですか？</b>
            <p>
              通常、数分〜15分ほどで入出金が完了いたします。<br>
              ただし、ブロックチェーンの混雑状況によりネットワークの確認に時間を要する場合がございます。
            </p>
          </li>

          <li>
            <b class="fw_bold"> KYC（本人確認）は必要ですか？</b>
            <p>
              はい、ご出金前には、KYC（本人確認書類）のアップロードおよび審査の完了が必要です。<br>
              ご本人確認が完了していない場合は、入金やプレイを始める前にご提出いただくことをおすすめいたします。<br>
              なお、KYCが完了していない場合は、出金をご利用いただけませんので、あらかじめご了承ください。
            </p>
          </li>

          <li>
            <b class="fw_bold"> 手数料はかかりますか？</b>
            <p>
              サイト側での手数料は無料です。ただし、ブロックチェーンのガス代の送金手数料が発生する場合がございます。
            </p>
          </li>

          <li>
            <b class="fw_bold"> ウォレット内で仮想通貨の交換はできますか？</b>
            <p>
              仮想通貨間の交換や、ウォレット間での資金移動は対応しておりません。<br>
              ご入金いただいた通貨にてプレイしていただき、同一通貨でのご出金をお願いいたします。
            </p>
          </li>

          <li>
            <b class="fw_bold"> セキュリティ面は大丈夫ですか？</b>
            <p>
              勝winでは、アカウントの安全性を高めるために、2段階認証（2FA）を導入しています。<br>
              ユーザー名とパスワードに加えて、ワンタイムコードによる認証を組み合わせることで、不正アクセスを防止し、セキュリティを強化しています。
            </p>
          </li>
        </ul>
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    scrollTo(id) {
      setTimeout(() => {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 10)
    }
  }
}
</script>
